<template>
  <div>
    <div
      v-show="$store.state.app.activeForm.length > 0"
      class="bd-b pd-b-5 mg-b-5"
    >
      <div class="d-flex align-items-center">
        <span class="mg-b-0 tx-14">Санал асуулга</span>
        <button
          class="btn btn-xs btn-warning text-white pd-y-2 pd-x-5 btn-uppercase mg-l-auto"
          @click="
            $router.push({
              name: 'lmsSurvey',
              params: {
                id: $store.state.app.activeForm[0].id,
                name: $store.state.app.activeForm[0].name
              }
            })
          "
        >
          Санал асуулгад оролцох
        </button>
      </div>
    </div>

    <div
      :key="i"
      v-for="(f, i) in $store.state.app.activeForm"
      @click="
        $router.push({ name: 'lmsSurvey', params: { id: f.id, name: f.name } })
      "
      class="alert alert-warning d-flex align-items-center"
      role="button"
    >
      <div class="pd-r-10">
        <feather class="wd-30-f ht-30-f" type="pie-chart"></feather>
      </div>
      <div>
        <div class="ivu-alert-message">{{ f.name }}</div>
        <hr class="mg-0-f" />
        <div class="ivu-alert-desc is-pointer">
          {{ f.startDate | moment("YYYYоны MM.DD HH:mm") }} -
          {{ f.endDate | moment("MM.DD HH:mm") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "futureFormList",
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
